import React from 'react';

import Catalog from 'files/Catalog.js';
import Coverage from 'views/site/Coverage.js';
import FAQ from 'views/site/FAQ.js';
import Graci from 'views/site/Graci.js';
import Guarantee from 'views/site/Guarantee.js';
import Hero from 'views/site/Hero.js';
import HowItWorks from 'views/site/HowItWorks.js';
import MobileApp from 'views/site/MobileApp.js';
import ProductGrid from 'views/site/ProductGrid.js';
import QuizCTA from 'views/site/QuizCTA.js';
import Stakes from 'views/site/Stakes.js';
import Testimonials from 'views/site/Testimonials.js';
import Theme from 'styles/Theme.js';
import TrustBar from 'views/site/TrustBar.js';
import WhyDifferent from 'views/site/WhyDifferent.js';

/*
 * Home
 *
 * Composition root for the marketing home page. The sequence follows the
 * storefront's own running order, carrying the in-home presentation's argument
 * inside it:
 *
 *   hero            white     the dealership's own name and town
 *   trust bar       dark      slim credibility strip
 *   coverage        tinted    proof of scale, and the installed base on a map
 *   stakes          white     3:30am, the numbers, the hazards
 *   walkthrough     tinted    first call to action, before the detail
 *   how it works    white     the network, in four steps
 *   why different   tinted    no monitoring fees, then minimum vs optimum
 *   products        white     the catalogue
 *   the app         tinted    living with it
 *   reviews         white     real Google reviews, or nothing at all
 *   guarantees      tinted    quoted from the manuals
 *   questions       white     objection handling
 *   walkthrough     tinted    second call to action, after the detail
 *
 * GROUNDS ALTERNATE WHITE AND TINTED, WITHOUT EXCEPTION. The page's entire
 * dark budget is three things — the trust strip, the walkthrough card, and the
 * footer — and that is what makes the walkthrough card read as an action
 * rather than as another band. Reordering means re-checking the alternation.
 */

const Home = ({ dealership, onAddToQuote, onOpenBlindSpots, onOpenQuiz, utils }) => {

    const onViewDetails = product => {
        utils.navigation.set({
            key: 'products',
            params: { handle: product.handle },
            view: 'products'
        });
    }

    if(!dealership) {
        return null;
    }

    // see Catalog.isVisible
    const showProducts = Catalog.isVisible(dealership);

    return (
        <div
        className={'site'}
        style={{
            backgroundColor: Theme.colors.white,
            width: '100%'
        }}>
            {/* The hero, and both walkthrough prompts below, open the blind
                spot checker rather than the coverage quiz. Someone landing on
                this page has not decided they want a network; asking them to
                spec one is a step too early. The coverage quiz stays on the
                products pages, where the visitor is already assembling. */}
            <Hero
            dealership={dealership}
            onOpenQuiz={onOpenBlindSpots}
            showProducts={showProducts} />

            <TrustBar />

            <Coverage dealership={dealership} />

            <Stakes />

            <QuizCTA
            dealership={dealership}
            onOpenQuiz={onOpenBlindSpots} />

            <HowItWorks showProducts={showProducts} />

            <WhyDifferent />

            {showProducts && (
                <ProductGrid
                dealership={dealership}
                onAddToQuote={onAddToQuote}
                onViewDetails={onViewDetails}
                products={Catalog.getAll(Catalog.getMode(dealership))} />
            )}

            {/* The product grid is the white band between two tinted ones.
                Without it the app section turns white so it doesn't merge
                into the tinted section above it. It then sits on white next
                to the assistant section, which reads better than two tinted
                bands running together. */}
            <MobileApp
            tinted={showProducts}
            utils={utils} />

            <Graci
            dealership={dealership}
            utils={utils} />

            <Testimonials
            dealership={dealership}
            utils={utils} />

            <Guarantee />

            <QuizCTA
            dealership={dealership}
            heading={'Ready to see what your home needs?'}
            onOpenQuiz={onOpenBlindSpots}
            subtext={'Takes about a minute. At the end you get a list of the rooms and dangers your alarms don\'t cover.'} />

            <FAQ dealership={dealership} />
        </div>
    )
}

export default Home;
